/**
 * Toggle Work page menu
 */

const workMenu = () => {
  const items = document.querySelectorAll('.js-workmenu');

  if (items) {
    items.forEach((item) => {
      item.addEventListener('click', () => {
        const prev = document.querySelector('.js-workmenu.active');
        if (item.classList.contains('active')) {
          item.classList.remove('active');
        } else {
          if (prev) {
            prev.classList.remove('active');
          }
          item.classList.add('active');
        }
      });
    });
  }
};

export default workMenu;
